export default __webpack_public_path__ + "static/media/KZ.T.10.0737.7c3b9786.svg";